export const launchPadRouteNames = {
  default: 'location-launchpad-v2',
  oldLaunchpad: 'location_launchpad',
}
